import { CampaignPlace } from '../../typings/campaignPlace';

export const INIT_CAMPAIGN_PLACE_EDITORS = 'INIT_CAMPAIGN_PLACE_EDITORS';
export type INIT_CAMPAIGN_PLACE_EDITORS = typeof INIT_CAMPAIGN_PLACE_EDITORS;

export interface InitCampaignPlaceEditors {
    type: INIT_CAMPAIGN_PLACE_EDITORS;
    payload: CampaignPlaceEditorInitData[];
}

export interface CampaignPlaceEditorInitData {
    editorId: string;
    place: CampaignPlace;
}

export function initCampaignPlaceEditorsAction(payload: CampaignPlaceEditorInitData[]): InitCampaignPlaceEditors {
    return {
        type: INIT_CAMPAIGN_PLACE_EDITORS,
        payload
    };
}
